import 'firebase/functions'

import firebase from 'firebase/app'
import { fns } from 'shopify-payment-core'

export function useFirebaseFunctions() {
  const functions = firebase.functions()

  const getRegistration: fns.getRegistration = functions.httpsCallable(
    'getRegistration',
  )

  const addRegistration: fns.addRegistration = functions.httpsCallable(
    'addRegistration',
  )

  const setBilling: fns.setBilling = functions.httpsCallable('setBilling')

  const setLanguage: fns.setLanguage = functions.httpsCallable('setLanguage')

  const changePaymentInstruments: fns.changePaymentInstruments = functions.httpsCallable(
    'changePaymentInstruments',
  )

  const deleteAccount: fns.deleteAccount = functions.httpsCallable(
    'deleteAccount',
  )

  return {
    addRegistration,
    getRegistration,
    setBilling,
    setLanguage,
    changePaymentInstruments,
    deleteAccount,
  }
}
